import { RefNumber, Checkbox, Text, Label } from "@tblabs/truffle";
import { Cost } from "../../../Services/Basket/Discount";
import { Svg } from "../../Components/Utils/Svg";


export class SingleCostBox extends Label
{
    constructor(cost: Cost, price: RefNumber)
    {
        super([
            new Checkbox(cost.IsOn).Class("product__discount-checkbox").Attribute("data-testid", "discount-checkbox-" + cost.Code.value),
            new Text(price, v => cost.AsString(+v)),
            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>`).Class("product__discount-info")
        ]); 

        this.Class("product__discount");

        if (cost.Description.value)
            this.Attribute("title", cost.Description.value);
    }
}
